__turbopack_context__.v({
  "hasTransition": "fIkcbW_hasTransition",
  "isCollapsed": "fIkcbW_isCollapsed",
  "wrapper": "fIkcbW_wrapper",
});
